// Stockholders Getters

export const getStockholdersList = state => {
  return state.stockholdersList
}

export const getStockholderInfo = state => {
  return state.stockholderInfo
}
